/** Compatibility styles for Morrow markup that predates semantic theme tokens. */
export const morrowSemanticThemeCss = `
.morrow-storefront {
    --morrow-ink: var(--site-inverse);
    --morrow-green: var(--site-primary);
    --morrow-apricot: var(--site-accent);
    --morrow-blue: var(--site-primary-soft);
}

.morrow-search-form,
.morrow-inner-panel,
.morrow-favorite,
.morrow-catalog-toolbar select,
.morrow-option-group button,
.morrow-quantity,
.morrow-cart-summary,
.morrow-delivery-card,
.morrow-auth-form,
.morrow-contact form,
.morrow-profile-form,
.morrow-upload,
.morrow-accordion,
.morrow-builder-form,
.morrow-chart,
.morrow-cta-badge,
.morrow-inner-card,
.morrow-countdown-block > div > span,
.morrow-inner-product {
    background: var(--site-surface);
    color: var(--site-on-surface);
}

.morrow-pickup input,
.morrow-form-grid input,
.morrow-form-grid textarea,
.morrow-auth-form input,
.morrow-profile-form input,
.morrow-contact input,
.morrow-contact textarea {
    background: var(--site-surface);
    color: var(--site-on-surface);
}

.morrow-search-form button,
.morrow-inner-panel button,
.morrow-product-meta button,
.morrow-product-meta > a,
.morrow-submit button,
.morrow-badge.is-primary {
    color: var(--site-on-primary);
}

.morrow-primary-button {
    color: var(--site-on-primary) !important;
}

.morrow-code,
.morrow-cart-count,
.morrow-pickup button,
.morrow-badge.is-dark,
.morrow-toast,
.morrow-region-footer {
    color: var(--site-on-inverse);
}

.morrow-header-cart-count,
.morrow-text-highlight,
.morrow-step > span,
.morrow-avatar {
    color: var(--site-on-accent);
}

.morrow-category-art.art-2,
.morrow-product-visual.tone-2,
.morrow-account-stats article,
.morrow-search-overlay {
    background: var(--site-primary-soft);
}

.morrow-category-art.art-3,
.morrow-product-visual.tone-3,
.morrow-quote {
    background: var(--site-accent-soft);
}

.morrow-product-visual,
.morrow-product-main-image,
.morrow-cart-thumb {
    background: var(--site-surface-elevated);
}

.morrow-product-visual.tone-1 {
    background: color-mix(in srgb, var(--site-accent) 34%, var(--site-background));
}

.morrow-rating-icons {
    color: var(--site-accent);
}

.morrow-delivery-card.is-selected {
    box-shadow: 0 0 0 2px color-mix(in srgb, var(--site-primary) 18%, transparent);
}

.morrow-overlay-backdrop {
    background: var(--site-overlay);
}

.morrow-cart-action,
.morrow-toast,
.morrow-code,
.morrow-cart-count,
.morrow-pickup button,
.morrow-region-footer {
    color: var(--site-on-inverse);
}

.morrow-toast {
    background: var(--site-inverse);
    border-color: color-mix(in srgb, var(--site-on-inverse) 16%, transparent);
}

.morrow-inner-icon-link:hover {
    background: color-mix(in srgb, var(--site-on-inverse) 15%, transparent) !important;
}

.morrow-progress,
.morrow-progress-track {
    background: var(--site-border);
}

.morrow-avatars span {
    background: var(--site-primary-soft);
    border-color: var(--site-surface);
    color: var(--site-on-surface);
}

.morrow-product-visual > span,
.morrow-favorite.is-active,
.morrow-step > span,
.morrow-avatar {
    background: var(--site-accent);
    color: var(--site-on-accent);
}

.morrow-option-group button.is-selected,
.morrow-pickup button {
    background: var(--site-inverse);
    border-color: var(--site-inverse);
    color: var(--site-on-inverse);
}

.morrow-stock-line span {
    background: var(--site-muted);
}

.morrow-stock-line span.is-available {
    background: var(--site-primary);
}

.morrow-product-meta .is-available {
    color: var(--site-primary);
}

.morrow-error {
    background: var(--site-accent-soft);
    border-color: var(--site-accent);
    color: var(--site-text);
}

.morrow-form-label sup {
    color: var(--site-accent);
}

.morrow-quote {
    background: var(--site-accent-soft);
    color: var(--site-text);
}

.morrow-badge.is-primary {
    background: var(--site-primary);
    color: var(--site-on-primary);
}

.morrow-badge.is-success,
.morrow-badge.is-info {
    background: var(--site-primary-soft);
    color: var(--site-text);
}

.morrow-badge.is-warning,
.morrow-badge.is-danger {
    background: var(--site-accent-soft);
    color: var(--site-text);
}

.morrow-badge.is-dark {
    background: var(--site-inverse);
    color: var(--site-on-inverse);
}

.morrow-cta-badge,
.morrow-countdown-block > div > span,
.morrow-inner-card,
.morrow-inner-product,
.morrow-upload,
.morrow-accordion,
.morrow-builder-form,
.morrow-chart {
    background: var(--site-surface);
    border-color: var(--site-border);
    color: var(--site-on-surface);
}

.morrow-rating-icons {
    color: var(--site-accent);
}

.morrow-progress-track > span.is-striped {
    background-image: repeating-linear-gradient(
        45deg,
        color-mix(in srgb, var(--site-on-primary) 28%, transparent) 0 7px,
        transparent 7px 14px
    );
}

.morrow-icon-text > span {
    background: var(--site-primary-soft);
    color: var(--site-on-surface);
}
`;
